import React from "react";
import styles from "../NotesPage.module.scss";
const Footer = () => {
  return (
    <div className={styles["note-app__footer"]}>
     
    </div>
  );
};

export default Footer;
